/* eslint-disable prettier/prettier */
/* eslint-disable import/order */
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IOrderData } from '@bvi/api-interfaces/response/manage-base-data';
import { EditOrderForm } from './edit-form';
import { PaperModal } from '@bvi/common-components';
import { useDeleteOrderMutation } from '@bvi/admin-panel/entities/order/api-slice';

interface IOrderActionMenuProperties {
  id: number;
  detail: IOrderData | null;
}

export const OrderActionMenu: FC<IOrderActionMenuProperties> = ({
  id,
  detail: _detail,
}) => {
  const { t } = useTranslation('translation');
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [deleteOrder] = useDeleteOrderMutation();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  const handleEdit = () => {
    setEditModalOpen(true);
    handleClose();
  };

  const handleDelete = async () => {
    try {
      await deleteOrder(id).unwrap();
    } catch {
      // Error handling - mutation will show error state
    }
    handleClose();
  };

  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        size="small"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorElement}
        keepMounted
        open={Boolean(anchorElement)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleEdit}>
          {t('manageList.actions.edit.caption')}
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          {t('manageList.actions.remove.caption')}
        </MenuItem>
      </Menu>
      <PaperModal open={isEditModalOpen} onClose={() => setEditModalOpen(false)}>
        <EditOrderForm
          id={id}
          onSuccess={() => setEditModalOpen(false)}
        />
      </PaperModal>
    </>
  );
};

